import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { ConfigurationOption } from '../configuration-option'

@Component({
  selector: 'configuration-option-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class ConfigurationOptionTableComponent {
  @Input() tableData: ConfigurationOption[]
  @Input() bulkActions: BulkAction[] = [BulkAction.DELETE]
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()

  @ViewChild('dataTable', { static: true }) dataTable: DataTable

  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public sortingField = 'description_desc'

  public onRowClicked(row: ConfigurationOption) {
    this.onClickRow.emit(row)
  }

  public onCheckRow(targetRow: ConfigurationOption) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }

  public onClickBulkAction(bulkOption: string) {
    const rows: ConfigurationOption[] = this.dataTable.data.filter((x) =>
      this.checkedIds.get(x.id)
    )

    if (rows.length > 0) {
      this.onBulkAction.emit({ action: bulkOption, items: rows })
    }
  }

  public onSortfieldClick(fieldName: string) {
    this.sortingField =
      this.sortingField == `${fieldName}_asc`
        ? `${fieldName}_desc`
        : `${fieldName}_asc`
  }
}
